<template>
  <!-- Штатный тултип Vuetify вместо директивы из пакета v-tooltip: на новых экранах
       проекта (доска ТС) используется он, и два механизма подсказок на соседних
       страницах ведут себя по-разному — разное позиционирование и задержки. -->
  <v-tooltip v-if="meta" bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon :color="meta.color" :small="small" v-on="on" v-bind="attrs">{{ meta.icon }}</v-icon>
    </template>
    <span>{{ $t(meta.key) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CarConditionIcon",
  props: {
    // { icon, color, key } из carConditionMeta; null — признак неизвестен, ничего не рисуем
    meta: { type: Object, default: null },
    small: { type: Boolean, default: false },
  },
};
</script>
